// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gd-0";
export var actionModalContentContainer = "_gd-1";
export var createTagButton = "_gd-2";
export var footerContainer = "_gd-7";
export var fullWidthDivider = "_gd-3";
export var hasCreateTagButton = "_gd-4";
export var noCreateTagButton = "_gd-5";
export var tagsContainer = "_gd-6";
export var tagsModalContentContainer = "_gd-8";